import { createMock } from './createMock';

/* eslint-disable @typescript-eslint/ban-types,no-console */
export const createConsoleLoggerMock = <T extends object>(
  baseName = 'analytics',
): T =>
  createMock([baseName], (fields, args) =>
    console.log(`${fields.join('.')}()`, ...args),
  );
